import { GeoBoundary } from "./GeoBoundary.js";

export class GeoObjectTbmBoundary extends GeoBoundary {

    constructor(objectTbm, data = {}) {

        super(objectTbm.modelSection, data);

        this.objectTbm = objectTbm ?? null;
        this.levelAboveTbmAxis = data.levelAboveTbmAxis ?? null;
        this.levelAboveTbmAxisGiven = data.levelAboveTbmAxisGiven ?? null;
        this.pressureSensor = data.pressureSensor ?? null;
        this.requiredMinimumSupportForceAtTunnelAxisFaxis1CalcEnabled = data.requiredMinimumSupportForceAtTunnelAxisFaxis1CalcEnabled ?? null;
        this.requiredMinimumSupportPressureP1CalcEnabled = data.requiredMinimumSupportPressureP1CalcEnabled ?? null;
        this.totalMinimumVerticalStressAtTunnelCrownPcrown1CalcEnabled = data.totalMinimumVerticalStressAtTunnelCrownPcrown1CalcEnabled ?? null;
        this.tunnelFaceRequiredSupportWaterForceInclSafetyCoefWcisCalcEnabled = data.tunnelFaceRequiredSupportWaterForceInclSafetyCoefWcisCalcEnabled ?? null;
        this.tunnelFaceRequiredSupportEarthForceInclSafetyCoefEmaxcisCalcEnabled = data.tunnelFaceRequiredSupportEarthForceInclSafetyCoefEmaxcisCalcEnabled ?? null;
        this.requiredMinimumSupportForceAtTunnelAxisInclSafetyCoefFaxis2SCalcEnabled = data.requiredMinimumSupportForceAtTunnelAxisInclSafetyCoefFaxis2SCalcEnabled ?? null;

    }

    get tbmAxisElevation() {
        return this.objectTbm?.axisElevation ?? null;
    }

    get tbmExcavationDiameter() {
        return this.objectTbm?.excavationDiameter ?? null;
    }

    get pressureSensorLevelAboveTbmAxis() {
        return this.pressureSensor?.levelAboveTbmAxis ?? null;
    }

}
